import actions from 'actions'
import { ActionCreator, AnyAction, Store } from 'redux'
import { ThunkAction as ReduxThunkAction } from 'redux-thunk'

import { trackCheckoutButtonPressed } from 'routes/Checkout/checkoutActions'

type ThunkAction<T = void> = ReduxThunkAction<T, Store<unknown>, any, AnyAction>
type ThunkActionCreator<T = void> = ActionCreator<ThunkAction<T>>

export const closeLoginModal: ThunkActionCreator = (e?: MouseEvent) => (dispatch) => {
  e?.stopPropagation()

  dispatch(actions.loginVisibilityChange(false))
}

export const openLoginModal: ThunkActionCreator =
  (e?: MouseEvent, isMobileView?: boolean) => (dispatch) => {
    e?.stopPropagation()

    dispatch(actions.loginVisibilityChange(true))

    if (isMobileView) {
      dispatch(trackCheckoutButtonPressed('LogInCTA Clicked'))
    }
  }
